import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Grid from "../../components/grid";
import ModalConfirmar from "../../components/modal-confirmar";
import "../../style/style-cargando.css";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_LISTAR_NUEVO } from "../../utils/const/estilos-const";
// import { obtenerPermisosPorNivelUsuarioWeb } from "../../api/permisos/permisos";
// import { TRUE } from "../../utils/const-bool";
// import ModalConfiguracionGrilla from "../../components/modal-configuracion-grilla";
// import { Settings } from "feather-icons-react/build/IconComponents";
import cargandoCard from "../../components/cargando-card";
import SinAccesoCard from "../../components/sin-acceso-card";
import { SELECT_HABILITADO_DESHABILITADO } from "../../utils/const/const-select-habilitado-deshabilitado";
import Select from "react-select";
import { sharedNextPage } from "../../utils/shared-functions";
import { INT_TIPO_USUARIO_ADMINISTRADOR_WEB } from "../../utils/const/int-const";
import { deshabilitarUsuarioWeb, habilitarUsuarioWeb, obtenerListaUsuariosWeb, restaurarContrasenaUsuarioWeb } from "../../api/usuario-web";
import { useTranslation } from "react-i18next";
import { STRING_COLOR_PRIMARIO, STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST, STRING_TIPO_USUARIO_CHECKLIST } from "../../utils/const/string-const";
import { COLOR_AZUL_MAIN } from "../../utils/const/colors-const";
import { obtenerPermisos } from "../../api/api-permisos";
import { PAGE_ID } from "../../utils/const/pages-const";
import ModalNuevaContrasena from "../../components/modal-nueva-contrasena";

export default function ListarUsuarioWeb() {

  const idTipoUsuario = localStorage.getItem(STRING_TIPO_USUARIO_CHECKLIST);
  const idSubTipoUsuarioWeb = localStorage.getItem(STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST);

  const { t } = useTranslation();
  const history = useHistory();
  const headers = [
    { key: "acciones", title: t('column_acciones'), visible: true, },
    { key: "id", title: "CODIGO", visible: false, },
    { key: "nombre", title: t('column_nombre'), filter: true, visible: true, },
    { key: "apellido", title: t('column_apellido'), filter: true, visible: true, },
    { key: "usuario", title: t('column_usuario'), filter: true, visible: true, },
    { key: "nota", title: t('column_nota'), filter: true, visible: true },
    { key: "idSubTipoUsuarioWeb", title: t('column_id_sub_tipo_usuario_web'), filter: true, visible: false },
    { key: "subTipoUsuarioWeb", title: t('column_sub_tipo_usuario_web'), filter: true, visible: true },
    { key: "fechaProceso", title: t('column_fecha_proceso'), filter: true, visible: true, },
  ];
  const [cargandoPage, setCargandoPage] = useState(true);
  const [listaUsuarios, setListaUsuarios] = useState([]);
  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] =
    useState(false);
  const [modalConfirmarRestaurarContrasenaVisible, setModalConfirmarRestaurarContrasenaVisible] = useState(false);
  const [usuarioMovilSelected, setUsuarioMovilSelected] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
  const [estadoHabilitadoSelected, setEstadoHabilitadoSelected] = useState(null);

  const [usuarioWebSelected, setUsuarioWebSelected] = useState(null);

  const [exportar, setExportar] = useState(true);
  const [gridHeaders, setGridHeaders] = useState(headers);
  const [colorMain, setColorMain] = useState(COLOR_AZUL_MAIN);

  const [btnNuevo, setBtnNuevo] = useState(false);
  const [btnBuscar, setBtnBuscar] = useState(false);

  useEffect(() => {
    // console.log("entro a ListarUsuarioWeb");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {

      let objConfiguracionEnviar = {};
      // objConfiguracionEnviar.descendente = true;
      // objConfiguracionEnviar.ascendente = false;
      objConfiguracionEnviar.habilitado = estadoHabilitadoSelected !== null ? estadoHabilitadoSelected.value : null;
      const colorBase = localStorage.getItem(STRING_COLOR_PRIMARIO);
      if (colorBase !== null) {
        setColorMain(colorBase);
      }

      let lista = [];
      let permiso = null;
      lista = await obtenerListaUsuariosWeb(objConfiguracionEnviar);
      if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        setBtnNuevo(true);
        setBtnBuscar(true);
        setTieneAccesoAlModulo(true);
      }
      if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        const objEnviar = {
          idSubTipoUsuarioWeb: idSubTipoUsuarioWeb,
        };
        const permisos = await obtenerPermisos(objEnviar);
        if (permisos.error === false && Array.isArray(permisos.data) && permisos.data.length > 0) {
          permiso = permisos.data[0];
        }
        const permisosInfo = JSON.parse(permisos.data[0].permisos);
        // console.log('permisosInfo');
        // console.log(permisosInfo);
        const permisosPage = permisosInfo.find(e => e.value === PAGE_ID.USUARIOS_WEB);
        // console.log('permisosPage');
        // console.log(permisosPage);
        setTieneAccesoAlModulo(permisosPage.checked === true);
      }
      agregarAccionesALista(lista, permiso);
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const agregarAccionesALista = (lista, permiso) => {
    try {
      const objModificar = {
        label: t('btn_modificar'),
        color: "green",
        onClick: (param) => editarUsuario(param),
      };
      const objDeshabilitar = {
        label: t('btn_deshabilitar'),
        color: "red",
        onClick: (param) => cambiarEstado(param),
      };
      const objHabilitar = {
        label: t('btn_habilitar'),
        color: "blue",
        onClick: (param) => cambiarEstadoHabilitar(param),
      };
      const objRestaurar = {
        label: t('btn_restaurar'),
        color: "orange",
        onClick: (param) => restaurar(param),
      };
      let btnModificar = false;
      let btnDeshabilitar = false;
      let btnHabilitar = false;
      let btnRestaurar = false;
      if (permiso !== null) {
        const parsePermisos = JSON.parse(permiso.permisos);
        const permisosPage = parsePermisos.find(e => e.value === PAGE_ID.USUARIOS_WEB);
        if (permisosPage !== undefined) {
          const acciones = permisosPage.acciones;
          if (acciones !== undefined) {
            const modificar = acciones.find(e => e.value === 'btn_modificar');
            if (modificar !== undefined) {
              btnModificar = modificar.checked;
            }
            const deshabilitar = acciones.find(e => e.value === 'btn_deshabilitar');
            if (deshabilitar !== undefined) {
              btnDeshabilitar = deshabilitar.checked;
            }
            const habilitar = acciones.find(e => e.value === 'btn_habilitar');
            if (habilitar !== undefined) {
              btnHabilitar = habilitar.checked;
            }
            const buscar = acciones.find(e => e.value === 'btn_buscar');
            if (buscar !== undefined) {
              setBtnBuscar(buscar.checked);
            }
            const nuevo = acciones.find(e => e.value === 'btn_nuevo');
            if (nuevo !== undefined) {
              setBtnNuevo(nuevo.checked);
            }
            const restaurar = acciones.find(e => e.value === 'btn_restaurar');
            if (restaurar !== undefined) {
              btnRestaurar = restaurar.checked;
            }
          }
        }
      }
      for (let i = 0; i < lista.length; i++) {
        const element = lista[i];
        let acciones = [];
        if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
          acciones.push(objModificar);
          if (element.habilitado === 1) {
            acciones.push(objDeshabilitar);
          }
          if (element.habilitado === 0) {
            acciones.push(objHabilitar);
          }
          acciones.push(objRestaurar);
        }
        if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
          if (btnModificar === true) {
            acciones.push(objModificar);
          }
          if (element.habilitado === 1 && btnDeshabilitar === true) {
            acciones.push(objDeshabilitar);
          }
          if (element.habilitado === 0 && btnHabilitar === true) {
            acciones.push(objHabilitar);
          }
          if (btnRestaurar === true) {
            acciones.push(objRestaurar);
          }
        }
        lista[i].acciones = acciones;
      }
      setListaUsuarios(lista);
    } catch (err) {
      console.log('agregarAccionesALista err');
      console.log(err);
    }
  }

  const editarUsuario = (data) => {
    try {
      // console.log("editarUsuario");
      // console.log(data);
      if (data.acciones !== undefined) {
        delete data.acciones;
      }
      let obj = {};
      obj.titulo = t('titulo_modificar_usuario_web');
      obj.params = data;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("usuario-web", obj, history);
    } catch (err) {
      console.log("editarUsuario err");
      console.log(err);
    }
  };

  const cambiarEstado = async (data) => {
    try {
      // console.log("cambiarEstado");
      // console.log(data);
      setUsuarioMovilSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstado err");
      console.log(err);
    }
  };

  const restaurar = async (data) => {
    try {
      console.log("restaurar");
      console.log(data);
      setUsuarioWebSelected(data);
      setModalConfirmarRestaurarContrasenaVisible(true);
    } catch (err) {
      console.log("restaurar err");
      console.log(err);
    }
  };

  const handleNuevoClick = () => {
    // console.log("handleNuevoClick");
    let obj = {};
    let data = {};
    data.id = 0;
    data.nombre = "";
    data.apellido = "";
    data.usuario = "";
    data.nota = "";
    data.telefono = "";
    obj.titulo = t('titulo_crear_usuario_web');
    obj.params = data;
    // nextPage("usuario-web", obj);
    sharedNextPage("usuario-web", obj, history);
  }

  const handleAtrasClick = () => {
    history.goBack();
  }

  const handleCancelModal = () => {
    setModalConfirmarDeshabilitarVisible(false);
  }

  const handleConfirmModal = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    if (usuarioMovilSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = usuarioMovilSelected.id;
    if (usuarioMovilSelected.id > 0) {
      // console.log('crear correo');
      let deshabilitado = await deshabilitarUsuarioWeb(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (deshabilitado === true) {
        alert(t('alert_se_deshabilito_correctamente'));
        reset();
      }
      if (deshabilitado === false) {
        alert(t('alert_no_se_pudo_procesar'));
      }
    }
  }

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  }

  const cambiarEstadoHabilitar = async (data) => {
    try {
      setUsuarioMovilSelected(data);
      setModalConfirmarHabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstadoHabilitar err");
      console.log(err);
    }
  };

  const handleCancelModalHabilitar = () => {
    setModalConfirmarHabilitarVisible(false);
  };

  const handleConfirmModalHabilitar = async () => {
    try {
      // console.log("Modal confirmado!");
      // console.log('tipoCarroceriaSelected');
      // console.log(tipoCarroceriaSelected);
      setModalConfirmarHabilitarVisible(false);
      let obj = {};
      obj.id = usuarioMovilSelected.id;
      const habilitado = await habilitarUsuarioWeb(obj);
      // console.log('habilitado');
      // console.log(habilitado);
      if (habilitado === true) {
        alert(t('alert_se_proceso_correctamente'));
        reset();
      }
      if (habilitado === false) {
        alert(t('alert_no_se_pudo_procesar'));
      }
    } catch (err) {
      console.log("handleConfirmModalHabilitar err");
      console.log(err);
    }
  };

  const handleConfirmModalRestaurarContrasena = async (password) => {
    try {
      console.log("handleConfirmModalRestaurarContrasena");
      console.log(password);
      console.log(usuarioWebSelected);
      const objEnviar = {
        id: usuarioWebSelected.id,
        password: password,
      };
      const restaurar = await restaurarContrasenaUsuarioWeb(objEnviar);
      if (restaurar === true) {
        alert(t('alert_se_proceso_correctamente'));
        // reset();
      }
      if (restaurar === false) {
        alert(t('alert_no_se_pudo_procesar'));
      }
      setModalConfirmarRestaurarContrasenaVisible(false);
      setUsuarioWebSelected(null);
    } catch (err) {
      console.log("handleConfirmModalRestaurarContrasena err");
      console.log(err);
    }
  };

  const handleEstado = (event) => {
    setEstadoHabilitadoSelected(event);
  }

  const handleBuscarClick = () => {
    reset();
  }

  const render = () => {
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return SinAccesoCard();
      }
      return (
        <div>
          <div
            style={{
              paddingTop: 5,
              paddingBottom: 5,
              paddingRight: 10,
              paddingLeft: 10,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <label
              style={{
                paddingLeft: 10,
                fontWeight: 'bold',
              }}
            >
              {t('titulo_lista_usuario_web')}
            </label>
            <div>
              {btnNuevo === true && (
                <button
                  type="button"
                  className={ESTILO_BOTON_LISTAR_NUEVO}
                  onClick={handleNuevoClick}
                  style={{
                    backgroundColor: colorMain,
                  }}
                >
                  {t('btn_nuevo')}
                </button>
              )}
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
              >
                {t('btn_atras')}
              </button>
            </div>
          </div>
          <div
            style={{
              paddingTop: 5,
              paddingBottom: 5,
              paddingRight: 10,
              paddingLeft: 10,
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <div className="flex align-center" >
              <Select
                options={SELECT_HABILITADO_DESHABILITADO}
                isSearchable={true}
                isClearable={true}
                value={estadoHabilitadoSelected}
                onChange={(event) => handleEstado(event)}
                placeholder={t('select_seleccionar_estado')}
              />
              <div
                style={{ width: 10 }}
              ></div>
              {btnBuscar === true && (
                <button
                  type="button"
                  className={ESTILO_BOTON_LISTAR_NUEVO}
                  onClick={handleBuscarClick}
                  style={{
                    backgroundColor: colorMain,
                  }}
                >
                  {t('btn_buscar')}
                </button>
              )}
            </div>
            {/* <button
              type="button"
              className={ESTILO_BOTON_LISTAR_ATRAS}
            >
              <Settings />
            </button> */}
          </div>
          <Grid rows={listaUsuarios} headers={gridHeaders}
            exportar={exportar} />
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={handleCancelModal}
            onConfirm={handleConfirmModal}
            message={t('alert_esta_seguro_de_deshabilitar_usuario')}
          />
          <ModalConfirmar
            isOpen={modalConfirmarHabilitarVisible}
            onCancel={handleCancelModalHabilitar}
            onConfirm={handleConfirmModalHabilitar}
            message={t('alert_esta_seguro_de_habilitar_usuario')}
          />
          <ModalNuevaContrasena
            isOpen={modalConfirmarRestaurarContrasenaVisible}
            onCancel={() => setModalConfirmarRestaurarContrasenaVisible(false)}
            onAccept={handleConfirmModalRestaurarContrasena}
            message={t('alert_esta_seguro_de_restaurar_contrasena')}
            usuario={usuarioWebSelected}
          />
          {/* <ModalConfiguracionGrilla
            modalConfiguracionVisible={modalConfiguracionVisible}
            onHideModalConfiguracion={onHideModalConfiguracion}
            ascendente={ascendente}
            descendente={descendente}
            setAscendente={setAscendente}
            setDescendente={setDescendente}
            gridHeaders={gridHeaders}
            setGridHeaders={setGridHeaders}
            onClickAcceptarOrdenGrillaModalConfiguracion={onClickAcceptarOrdenGrillaModalConfiguracion}
            onClickAcceptarHeadersGrillaModalConfiguracion={onClickAcceptarHeadersGrillaModalConfiguracion}
          /> */}
        </div>
      );
    } catch (err) {
      console.log('index render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
